import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M4 8v3a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Zm5 2.5v-2a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 1a1 1 0 0 1 1-1h8v4h4v11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1Zm2 6H3v5h1a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Zm9.5 1h.5V7h-.5a2.5 2.5 0 0 0 0 5h.5v-1h-.5a1.5 1.5 0 0 1 0-3Zm-5-1A1.5 1.5 0 0 0 7 8.5v2a1.5 1.5 0 0 0 3 0v-2A1.5 1.5 0 0 0 8.5 7Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12 3V0l3 3h-3Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconFileDoc16 = createIcon(IconComponent);